<template>
  <div>
    <chart-card
      class="chart-order-container"
      :chartType="'bar'"
      :fromTo="fromTo"
      :chartOptions="chartOptions"
      :chartData="chartData"
      :title="title"
      :totalValue="getTotalAmountText()"
      :subTitle="subTitleComputed"
      @acceptParams="acceptParams()"
    >
    </chart-card>
  </div>
</template>

<script>
import axios from "axios";
import ChartCard from "@/components/Cards/ChartCard";
import mixins from "@/mixins";
import moment from "moment";

export default {
  mixins: [mixins],
  components: {
    ChartCard,
    // DateRangePicker,
  },
  data() {
    return {
      isShowChart: false,
      title: window.__t('js.thong_ke_chi_phi_theo_thoi_gian'),
      fromTo: {},
      chartOptions: {
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            dataLabels: {
              position: "top", // top, center, bottom
            },
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [],
          position: "bottom",
          labels: {
            rotate: 0,
            hideOverlappingLabels: true,
          },
          tickAmount: 5,
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              if (val > 0) return val;
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return window.__t('js.value_trieu', { value: val });
            },
          },
        },
      },
      chartData: [
        {
          name: window.__t('js.chi_phi'),
          data: [],
        },
      ],
      tableData: [],
      totalAmount: 0,
    };
  },
  mounted: function () {
    this.reloadChartDate();
  },
  computed: {},
  methods: {
    getTotalAmountText() {
      return window.__t('js.tong_chi_phi_amount_trieu', { amount: this.totalAmount });
    },
    formatStringDate(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    acceptParams: function () {
      this.reloadChartDate();
    },
    reloadChartDate: function () {
      const fromDate = moment().startOf("month").format("YYYY-MM-DD"),
        toDate = moment().endOf("month").format("YYYY-MM-DD");
      this.fromTo.fromDate = moment().startOf("month").format("DD/MM");
      this.fromTo.toDate = moment().endOf("month").format("DD/MM");
      axios
        .get("c-report/amount", {
          params: {
            fromDate,
            toDate,
          },
        })
        .then((res) => {
          let resultData = res.data;
          if (resultData.data && resultData.data.length > 0)
            this.tableData = resultData.data.map((x) => {
              return {
                order_date: this.formatDate(x.order_date),
                amount: +x.amount,
              };
            });
          if (resultData.data.length < 8) {
            this.chartOptions = {
              xaxis: {
                categories: resultData.data.map((x) =>
                  this.formatDate(x.order_date)
                ),
              },
            };
          } else {
            let temp = resultData.data.map((x) => {
              return +resultData.data.indexOf(x) + 1;
            });
            this.chartOptions = {
              xaxis: {
                categories: temp,
              },
            };
          }
          this.chartData = [
            {
              data: resultData.data.map((x) => +x.amount / 1000000),
            },
          ];
          this.totalAmount = resultData.data.reduce(
            (total, current) => total + +current.amount / 1000000,
            0
          );
        })
        .finally(() => {
          // loader.hide();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.mobile-report {
  margin: auto;
  th {
    height: 40px;
  }
  .count {
    border: 1px solid #cccccc;
    text-align: right;
    width: 100px;
    padding-right: 10px;
  }

  .order_date {
    border: 1px solid #cccccc;
    width: 180px;
    text-align: center;
  }

  tr {
    height: 30px;
  }

  tr:last-child {
    td {
      font-weight: bold;
    }
  }

  .total-text {
    text-align: center;
  }

  .total-value {
    text-align: right;
    padding-right: 10px;
  }
}
.drp-buttons {
  .cancelBtn {
    background-color: transparent;
    color: #000000;
    border: none;
  }
  .applyBtn {
    background-color: #1976d2;
    border-color: #1976d2;
    &:hover {
      background-color: #1976d2;
      border-color: #1976d2;
    }
  }
}

@media screen and (min-width: 768px) {
  .daterangepicker.dropdown-menu.ltr.show-calendar.show-ranges.openscenter.linked {
    min-width: 650px;
    padding: 0;
  }
}
</style>
